import * as React from 'react';
import {Dispatch, SetStateAction} from 'react';

import {AutoRoShipmentItem} from '../../auto-reorders/AutoReorderClass';
import {CardItem} from '../item.class';
import {CardOptions, ItemCard} from './ItemCard';
import {GaItemListName} from '../../../client/ga/ga-ecommerce.functions';
import {ItemCardAlert} from './ItemCardAlerts';
import {ItemToAdd} from '../../order-items/order-items.class';
import {OrdersService} from '../../../client/orders/orders.service';
import {ShareLinkType} from '../../share-link/share-link.class';
import {User} from '../../users/user.class';
import {useService} from '../../react/ServiceContext';

interface ItemCardsProps {
    cardOptions: CardOptions;
    componentName: string;
    deleteAutoRoItemConfirm?: (autoRoShipmentItem: AutoRoShipmentItem, showModal: boolean) => void;
    editEnrollmentShow?: (itemNum: string) => void;
    gaItemListName: GaItemListName;
    itemCardAlert?: ItemCardAlert;
    items: CardItem[];
    onEnrollAutoReorder?: (itemToAdd: ItemToAdd) => void;
    onInventoryControl?: (cardItem: CardItem) => void;
    onRemove?: (itemNum: string, bin?: string) => void;
    onReplace?: (oldItemNum: string, quantity: number, categoryPath?: string, shipmentDate?: string) => void;
    onStepperUpdate?: (itemNum: string, qty: number) => void;
    onStepperUpdateAllowInvalid?: boolean;
    recordItemCheckbox?: (id: string, checked: boolean) => void;
    setShareLinkModal?: Dispatch<SetStateAction<{linkId: string; linkType: ShareLinkType; show: boolean}>>;
    toggleAutoRoShipmentItemStatusConfirm?: () => void;
    user?: User;
}

export const ItemCards = ({
    cardOptions,
    componentName,
    deleteAutoRoItemConfirm = () => null,
    editEnrollmentShow = () => null,
    gaItemListName,
    itemCardAlert,
    items,
    onEnrollAutoReorder,
    onInventoryControl,
    onRemove,
    onReplace,
    onStepperUpdate,
    onStepperUpdateAllowInvalid,
    recordItemCheckbox,
    setShareLinkModal,
    toggleAutoRoShipmentItemStatusConfirm = () => null,
    user,
}: ItemCardsProps) => {
    const ordersService: OrdersService = useService(`ordersService`);

    if (items?.length > 0) {
        return (
            <div className="tw-grid tw-grid-cols-1 tw-m-0">
                {items.map((cardItem, index) => (
                    <ItemCard
                        cardItem={cardItem}
                        cardOptions={cardOptions}
                        componentName={componentName}
                        deleteAutoRoItemConfirm={deleteAutoRoItemConfirm}
                        editEnrollmentShow={editEnrollmentShow}
                        gaItemListName={gaItemListName}
                        hidden={cardItem?.hidden}
                        index={index}
                        itemCardAlert={itemCardAlert}
                        key={`${componentName}_${cardItem.item || cardItem.id}`}
                        onEnrollAutoReorder={onEnrollAutoReorder}
                        onInventoryControl={(listItem) => {
                            onInventoryControl(listItem);
                        }}
                        onRemove={onRemove}
                        onReplace={onReplace}
                        onStepperUpdate={(item, qty) => {
                            if (onStepperUpdate) {
                                onStepperUpdate(item, qty);
                            }
                        }}
                        onStepperUpdateAllowInvalid={onStepperUpdateAllowInvalid}
                        orderNumber={ordersService?.currentOrderNumber}
                        recordItemCheckbox={recordItemCheckbox}
                        setShareLinkModal={setShareLinkModal}
                        toggleAutoRoShipmentItemStatusConfirm={toggleAutoRoShipmentItemStatusConfirm}
                        unitsOrdered={cardItem?.unitsOrdered || cardItem?.quantity}
                        user={user}
                    />
                ))}
            </div>
        );
    }
    return null;
};
